// Page.js
import React from 'react';
import Home from '../../contaniers/Home/Home';
import About from '../../contaniers/about/About';
import Skill from '../../contaniers/skills/Skill';
import Project from '../../contaniers/project/Project';
import Contact from '../../contaniers/contact/Contact';

const Page = () => {
  return (
    <div className={`w-screen`}>
      <Home />
      <About />
      <Skill />

      <Project />
      <Contact />
    </div>
  );
};

export default Page;
